import { ReactNode } from 'react';
import { cn } from 'v5/platform/dom/cn';

export interface EntityHeaderProps {
  /**
   * <img/> or some more sophisticated image loading component
   */
  profileImageContent: ReactNode;
  /**
   * <img/> or some more sophisticated image loading component
   */
  backgroundImageContent: ReactNode;
  /**
   * title string content
   */
  titleContent: ReactNode;
  /**
   * subtitle string content
   */
  subtitleContent: ReactNode;
  /**
   * actions menu content - toolbar with overflow menu etc
   */
  actionsContent: ReactNode;
  className?: string;
  extraContent?: ReactNode;
}

export function EntityHeader({
  profileImageContent,
  backgroundImageContent,
  titleContent,
  subtitleContent,
  actionsContent,
  className,
  extraContent
}: EntityHeaderProps) {
  return (
    <div
      className={cn(
        'min-w-min [--entity-header-px:calc(var(--spacing)*8)] relative w-full bg-bg-default grid grid-cols-[1fr_auto] grid-rows-[100px_auto_auto_auto]',
        className
      )}
    >
      <div className="col-span-2 col-start-1 row-start-1">
        {backgroundImageContent}
      </div>
      <div className="mx-(--entity-header-px) self-end mt-12 col-start-1 row-start-1 row-span-2 isolate">
        {profileImageContent}
      </div>
      <div className="mx-(--entity-header-px) col-start-2 row-start-2 mt-3 mr-3">
        {actionsContent}
      </div>
      <div className="mx-(--entity-header-px) mt-5 col-span-2 row-start-4 space-y-2">
        {subtitleContent}
        {titleContent}
        {extraContent}
      </div>
    </div>
  );
}
